// src/pages/orders/OrderDetail.jsx
import React from "react";
import { useParams } from "react-router-dom";
import { Grid, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import LoadingPage from "../../components/global/LoadingPage";

import { useGetOrderById } from "../../hooks/orders/useGetOrderById";

import OrderHeader from "../../components/orders/Detail/OrderHeader";
import OrderItemsEditor from "../../components/orders/Detail/OrderItemsEditor";
import OrderTotalsCard from "../../components/orders/Detail/OrderTotalsCard";
import OrderTimeline from "../../components/orders/Detail/OrderTimeline";
import OrderNotes from "../../components/orders/Detail/OrderNotes";
import OrderCustomerCard from "../../components/orders/Detail/OrderCustomerCard";
import OrderAddressesCard from "../../components/orders/Detail/OrderAddressesCard";
import OrderPaymentCard from "../../components/orders/Detail/OrderPaymentCard";
import OrderShippingCard from "../../components/orders/Detail/OrderShippingCard";
import OrderActionsPanel from "../../components/orders/Detail/OrderActionsPanel";
import LateRefundBanner from "../../components/orders/Detail/LateRefundBanner";
import OrderDebugInfo from "../../components/orders/Detail/OrderDebugInfo";

const OrderDetail = () => {
    const { id } = useParams();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const { order, isLoading, error, refetch } = useGetOrderById(id);

    if (isLoading) return <LoadingPage />;
    if (error || !order) {
        return (
            <WrapperSection>
                <GlobalBreadcrumbs />
                <Box sx={{ p: 4, textAlign: "center" }}>
                    <Typography variant="h6" color="error">
                        {isArabic ? "تعذر تحميل تفاصيل الطلب" : "Failed to load order details"}
                    </Typography>
                </Box>
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />

            <LateRefundBanner order={order} />

            <Grid container spacing={3} sx={{ mt: 1 }}>
                {/* Left column — 60% */}
                <Grid item xs={12} md={7}>
                    <OrderHeader order={order} />
                    <OrderItemsEditor order={order} onSaved={refetch} />
                    <OrderTotalsCard order={order} />
                    <OrderTimeline orderId={order.id} />
                    <OrderNotes orderId={order.id} />
                </Grid>

                {/* Right column — 40% */}
                <Grid item xs={12} md={5}>
                    <OrderCustomerCard order={order} />
                    <OrderAddressesCard order={order} />
                    <OrderPaymentCard order={order} />
                    <OrderShippingCard order={order} />
                    <OrderActionsPanel order={order} />
                    <OrderDebugInfo order={order} />
                </Grid>
            </Grid>
        </WrapperSection>
    );
};

export default OrderDetail;
